// components/CustomerType.js
import React from 'react';
import styled from 'styled-components';

import { BaseLabel, RadioLabel, RowContainer, InputSmall, Select, Label, cores } from '../../../../styles/styleUtils';

const CustomerTypeContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  align-items: center;
`;


const RadioButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 15px;
`;

const RadioButton = styled.input`
  margin-right: 5px;
`;

const RadioLabel2 = styled.label`
  font-size: 14px;
  color: ${cores.cinzaMedio};
`;

const ImportButton = styled.button`
  background-color: ${cores.laranja};
  color: ${cores.textoClaro};
  border: none;
  border-radius: 5px;
  padding: 8px 15px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;
const tipos = ['Véiculo', 'Informática', 'Móveis', 'Eletrodoméstico', 'Telefonia'];

function AtivoImobilizadoType({ tipoAtivoImobilizado, onTypeChange, disabled, formData, onInputChange }) {
  return (
    <div>
      <CustomerTypeContainer>
        <BaseLabel>Tipo Ativo Imobilizado</BaseLabel>
        {tipos.map((tipo) => {
          return (
            <RadioButtonWrapper key={tipo}>
              <RadioButton
                type="radio"
                name="tipoAtivoImobilizado"
                value={tipo}
                checked={tipoAtivoImobilizado === tipo}
                onChange={onTypeChange}
                disabled={disabled}
              />
              <RadioLabel>{tipo}</RadioLabel>
            </RadioButtonWrapper>
          );
        })}
      </CustomerTypeContainer>
      <RowContainer>
        <BaseLabel htmlFor="depreciacao">Depreciação (%)</BaseLabel>
        <InputSmall
          type="number"
          id="depreciacao"
          name="depreciacao"
          value={formData.depreciacao || ''}
          onChange={onInputChange}
        />
        <div style={{ width: 5 }} />
        <Label htmlFor="periodicidadeDepreciacao">Periodicidade Depreciação</Label>
        <Select
          id="periodicidadeDepreciacao"
          name="periodicidadeDepreciacao"
          value={formData.periodicidadeDepreciacao}
          onChange={onInputChange}
        >
          <option value="">Selecione</option>
          <option value="quinzenal">Quinzenal</option>
          <option value="mensal">Mensal</option>
          <option value="bimestral">Bimestral</option>
        </Select>
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="vidaUtil">Vida Util</BaseLabel>
        <InputSmall
          type="number"
          id="vidaUtil"
          name="vidaUtil"
          value={formData.vidaUtil || ''}
          onChange={onInputChange}
        />
      </RowContainer>
      <RowContainer>
        <BaseLabel htmlFor="estadoAtivo">Estado</BaseLabel>
        <Select id="estadoAtivo" name="estadoAtivo" value={formData.estadoAtivo} onChange={onInputChange}>
          <option value="">Selecione</option>
          <option value="novo">Novo</option>
          <option value="usado">Usado</option>
        </Select>
      </RowContainer>
    </div>
  );
}

export default AtivoImobilizadoType;